import { defineStore } from 'pinia';
import { ref } from 'vue';

export const SETUP_DISMISSED_STORAGE_KEY = 'nori_setup_command_dismissed';

export const useSetupPreferenceStore = defineStore('setupPreference', () => {
  const isDismissed = ref<boolean>(false);

  const dismissSetup = (): void => {
    isDismissed.value = true;
    localStorage.setItem(SETUP_DISMISSED_STORAGE_KEY, 'true');
  };

  const showSetup = (): void => {
    isDismissed.value = false;
    localStorage.setItem(SETUP_DISMISSED_STORAGE_KEY, 'false');
  };

  const initialize = (): void => {
    try {
      const stored = localStorage.getItem(SETUP_DISMISSED_STORAGE_KEY);

      if (stored === 'true') {
        isDismissed.value = true;
      } else {
        isDismissed.value = false;
      }
    } catch {
      isDismissed.value = false;
    }
  };

  return {
    isDismissed,
    dismissSetup,
    showSetup,
    initialize,
  };
});
